import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminBannerStatus } from '../enums/admin-banner-status';

@Injectable({
  providedIn: 'root',
})
export class AdminBannerStatusProviderService {
  private readonly entries = new Map<AdminBannerStatus, string>([
    [AdminBannerStatus.Active, 'Aktywny'],
    [AdminBannerStatus.Inactive, 'Nieaktywny'],
  ]);

  public labelFor(status: AdminBannerStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBannerStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
